import { facebook } from './facebook';
import { fileUpload } from './file-upload';
import * as idEndpoints from './id';
import { id, root } from './social-media';

export const socialMedia = {
  ...root,
  facebook,
  fileUpload,
  id: {
    ...id,
    ...idEndpoints,
  },
};
